// extracted by mini-css-extract-plugin
export default {"matchbutton":"matchbutton_matchbutton__apDV0","wrong":"matchbutton_wrong__Lh2IZ","shake":"matchbutton_shake__MWo3k"};